module.exports = __webpack_public_path__ + "static/media/frame1.7ec8b242.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/frame-top/frame1.png
// module id = 60
// module chunks = 0